<div class="divText">
  <img
    class="imageU"
    [src]="user.photo ? user.photo : 'assets/images/user.png'"
  />
  <!-- <h3 class="text">{{ user?.username }}</h3> -->
  <h3 class="text">{{ user?.fullname }}</h3>
</div>
